export default "__VITE_ASSET__B8t7BGHD__"